module.exports = __webpack_public_path__ + "img/separator17.8eb739ee.svg";